import type { ReactNode } from "react";
import { cn } from "@repo/utils";

export interface NavigationProps {
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function Navigation({ children, footer, className }: NavigationProps) {
  return (
    <nav
      className={cn(
        "sticky top-0 flex h-screen w-80 shrink-0 flex-col overflow-hidden border-r border-gray-200 bg-white",
        className
      )}
    >
      <div
        className={cn(
          "isolate flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto overscroll-contain p-4",
          "[scrollbar-color:var(--color-gray-300)_transparent] [scrollbar-width:thin]"
        )}
      >
        {children}
      </div>

      {footer && <div className="h-18 shrink-0 border-t border-gray-200 bg-white">{footer}</div>}
    </nav>
  );
}
Navigation.displayName = "Navigation";
